import React, { useState } from 'react';
import {
  BrowserRouter as Router,
  Route,
  //useParams
} from 'react-router-dom';

//import logo from './logo.svg';
import './css/App.css';
import Header from './components/header';
import Footer from './components/footer';
// import Homepage from './components/homePage';
import News from './components/news';
import Stocks from './components/stocks/stocks';
import Crypto from './components/crypto';
import About from './components/about';
import Login from './components/login';
import Profile from './components/profile';

//import Data from './components/data';
// import Plot from './components/plot';

// require('dotenv').config();

function App() {
  const [selectedTicker, setSelectedTicker] = useState('AAPL');
  const [stockSearchTerm, setStockSearchTerm] = useState('');
  const [selectedCryptoSymbol, setSelectedCryptoSymbol] = useState('X:BTCUSD');
  const [cryptoSearchTerm, setCryptoSearchTerm] = useState('');

  // const handleLoginClick = (e) => {
  //   // Force reload of the login component
  //   window.location.href = '/login';
  // };

  return (
    <Router basename="/">
      <div className="App">
        <Header
          selectedTicker={selectedTicker}
          stockSearchTerm={stockSearchTerm}
          onStockSearchChange={setStockSearchTerm}
          onTickerSelect={setSelectedTicker}
          selectedCryptoSymbol={selectedCryptoSymbol}
          cryptoSearchTerm={cryptoSearchTerm}
          onCryptoSearchChange={setCryptoSearchTerm}
          onCryptoSelect={setSelectedCryptoSymbol}
        />
        <div className="app-content">
          <Route exact path="/" component={News} />
          {/* <Route exact path='/News' component={News}/> */}
          {/* <Route path="/Stocks/:dataId?" component={Stocks} /> */}
          <Route
            exact
            path="/Stocks"
            render={(routeProps) => (
              <Stocks
                {...routeProps}
                selectedTicker={selectedTicker}
                stockSearchTerm={stockSearchTerm}
              />
            )}
          />
          <Route
            exact
            path="/Crypto"
            render={(routeProps) => (
              <Crypto
                {...routeProps}
                selectedSymbol={selectedCryptoSymbol}
                onSymbolChange={setSelectedCryptoSymbol}
                cryptoSearchTerm={cryptoSearchTerm}
              />
            )}
          />
          <Route exact path="/About" component={About} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/profile" component={Profile} />
          {/* <Route path='/:dataId' component={Data}/> */}
          {/* <Plot/> */}
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
